import { ar, en } from '@dob/i18n';

import type { CodeFields } from '../../forms.ts';

/** Password-change refusals shown under the field they concern. */
export const PASSWORD_CHANGE_CODE_FIELDS: CodeFields = {
  INVALID_CREDENTIALS: {
    field: 'currentPassword',
    message: { ar: ar.auth.currentPasswordWrong, en: en.auth.currentPasswordWrong },
  },
  WEAK_SECRET: 'newPassword',
};

/** Password reset by code: a wrong code belongs to the code field, a weak password to its own. */
export const PASSWORD_RESET_CODE_FIELDS: CodeFields = {
  INVALID_CODE: 'code',
  WEAK_SECRET: 'newPassword',
};
